import React from 'react'
import PropTypes from 'prop-types'

import AsyncSelect from 'react-select/async'

import { makeStyles, useTheme } from '@material-ui/core'

import Control from './components/control'
import Menu from './components/menu'
import MultiValue from './components/multiValue'
import NoOptionsMessage from './components/noOptionsMessage'
import Option from './components/option'
import Placeholder from './components/placeholder'
import SingleValue from './components/singleValue'
import ValueContainer from './components/valueContainer'

const components = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    height: 250
  },
  divider: {
    height: theme.spacing(2)
  }
}))

const ZariAsyncSelect = React.forwardRef(
  ({ selectId, loadOptions, onChange, onKeyDown, defaultMenuIsOpen, autoFocus, isSearchable, isClearable }, ref) => {
    const classes = useStyles()
    const theme = useTheme()
    const delayRef = React.useRef(null)

    const selectStyles = {
      input: base => ({
        ...base,
        color: theme.palette.text.primary,
        '& input': {
          font: 'inherit',
          fontSize: '0.875rem !important'
        }
      }),
      dropdownIndicator: () => ({ display: 'none' }),
      indicatorsContainer: () => null,
      indicatorSeparator: () => null,
      clearIndicator: () => ({ padding: '0px' })
    }

    const loadOptionsSelect = React.useCallback(
      (inputValue, callBack) =>
        new Promise(resolve => {
          if (delayRef.current) {
            clearTimeout(delayRef.current)
          }
          if (inputValue !== null) {
            delayRef.current = setTimeout(() => callBack(inputValue, resolve), 350)
          } else {
            resolve([])
          }
        }),
      []
    )

    return (
      <AsyncSelect
        ref={ref}
        isSearchable={isSearchable}
        isClearable={isClearable}
        classes={classes}
        styles={selectStyles}
        inputId={selectId}
        placeholder=''
        TextFieldProps={{
          InputLabelProps: {
            htmlFor: selectId,
            shrink: true
          }
        }}
        components={components}
        loadOptions={inputValue => loadOptionsSelect(inputValue, loadOptions)}
        noOptionsMessage={({ inputValue }) => {
          if (inputValue === '') {
            return 'Buscar ...'
          } else {
            return 'No se han encontrado resultados.'
          }
        }}
        onChange={onChange}
        defaultMenuIsOpen={defaultMenuIsOpen}
        autoFocus={autoFocus}
        maxMenuHeight={150}
        onKeyDown={onKeyDown}
      />
    )
  }
)

ZariAsyncSelect.propTypes = {
  selectId: PropTypes.string.isRequired,
  loadOptions: PropTypes.any.isRequired,
  onChange: PropTypes.any.isRequired,
  defaultMenuIsOpen: PropTypes.bool,
  autoFocus: PropTypes.bool
}

ZariAsyncSelect.displayName = 'ZariAsyncSelect'

export default ZariAsyncSelect
